// @ts-nocheck
const scrollToId = (id: string, smooth?: boolean) => {
    const idToScrollTo = document.getElementById(id);
    const viewportPosition = idToScrollTo?.getBoundingClientRect().top || 0;
    const viewportToDocument = window.scrollY;
    const scrollTopPx = viewportPosition + viewportToDocument;

    if (smooth) {
        window.scrollTo({
            top: scrollTopPx,
            behavior: "smooth",
        });
    } else {
        document.body.scrollTop = scrollTopPx; // Safari
        document.documentElement.scrollTop = scrollTopPx; // Chrome, Firefox, IE and Opera
    }
};

export default scrollToId;
